import { motion } from "framer-motion";
import { BRAND, LOGOS } from "@/brand";

const SHOTS = [
  {
    src: "/brand/campaign-17.webp",
    caption: "FRAME 01 — Ghetto Diaries back collage, chain-link",
    raw: true,
  },
  {
    src: "/brand/campaign-18.webp",
    caption: "FRAME 02 — Ghetto Diaries front portrait, garage",
    raw: true,
  },
  {
    src: "/brand/campaign-19.webp",
    caption: "FRAME 03 — Ghetto Diaries full back, same pain different art",
    raw: true,
  },
  {
    src: "/brand/campaign-20.webp",
    caption: "FRAME 04 — Ghetto Diaries hood-up front, CXMXII cap",
    raw: true,
  },
];

export default function Lookbook() {
  return (
    <section id="lookbook" data-testid="lookbook-collection-section" className="relative py-28 sm:py-36 border-t border-zinc-800/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 mb-14">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-[10px] tracking-[0.45em] text-zinc-600 uppercase mb-4"
        >
          Lookbook — Shot on Concrete
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-5xl sm:text-7xl chrome-text uppercase"
        >
          Worn by the Fearless
        </motion.h2>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-8 mb-20 grid grid-cols-1 lg:grid-cols-[1.25fr_1fr] gap-6 items-start">
        <motion.figure
          data-testid="lookbook-campaign-board"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="border border-zinc-700/70 bg-zinc-950 p-2 sm:p-3 shadow-[0_30px_80px_rgba(0,0,0,0.6)]"
        >
          <div className="border border-zinc-800/80 overflow-hidden">
            <img
              src="/brand/product-dairies-hoodie.webp"
              alt="Vault 001 — The Fir$t I$$ue official design board"
              loading="lazy"
              className="w-full transition-transform duration-700 hover:scale-[1.02]"
            />
          </div>
          <figcaption className="flex items-center justify-between gap-4 px-2 pt-3 pb-1 text-[9px] tracking-[0.35em] uppercase">
            <span className="text-zinc-300">Vault 001 — The Fir$t I$$ue</span>
            <span className="text-zinc-600">Official Design Board</span>
          </figcaption>
        </motion.figure>

        <motion.figure
          data-testid="lookbook-emblem-feature"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="relative border border-zinc-800/80 overflow-hidden lg:mt-16"
        >
          <img src={LOGOS.emblem} alt={`${BRAND.name} studios emblem`} className="logo-blend w-full" />
          <figcaption className="absolute bottom-4 left-4 text-[9px] tracking-[0.35em] text-zinc-300 uppercase bg-[#0A0A0B]/60 backdrop-blur px-2 py-1">
            Studios Emblem — Drop Artwork 001
          </figcaption>
        </motion.figure>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-4 sm:px-8 max-w-7xl mx-auto">
        {SHOTS.map((s, i) => (
          <motion.figure
            key={s.caption}
            data-testid={`lookbook-frame-${i + 1}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden border border-zinc-800/80 ${i % 2 === 1 ? "lg:mt-12" : ""}`}
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={s.src}
                alt={s.caption}
                loading="lazy"
                className={`h-full w-full object-cover transition-[transform,filter] duration-700 group-hover:scale-105 ${
                  s.raw ? "object-top" : "grayscale group-hover:grayscale-0"
                }`}
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B]/85 via-transparent to-transparent" />
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
